import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuxiliaryAccountsEquationsModule } from '@components/model-data/auxiliary-accounts-equations/auxiliary-accounts-equations.module';
import { ExogenousLinesEquationsModule } from '@components/model-data/exogenous-lines-equations/exogenous-lines-equations.module';
import { LiquiditySourceEquationsModule } from '@components/model-data/liquidity-source-equations/liquidity-source-equations.module';
import { LookupDataComponent } from '@components/model-data/lookup-data/lookup-data.component';
import { LookupDatabase } from '@components/model-data/lookup-tree/helpers/lookup-database';
import { LookupTreeModule } from '@components/model-data/lookup-tree/lookup-tree.module';
import { BalanceSheetModule } from '@components/model-structure/balance-sheet/balance-sheet.module';
import { ExogenousLinesModule } from '@components/model-structure/exogenous-lines/exogenous-lines.module';
import { GlobalSettingsComponent } from '@components/model-structure/global-settings/global-settings.component';
import { LiquiditySourcesModule } from '@components/model-structure/liquidity-sources/liquidity-sources.module';
import { LookupSetupComponent } from '@components/model-structure/lookup-setup/lookup-setup.component';
import { ScenariosModule } from '@components/model-structure/scenarios/scenarios.module';
import { ResultsModule } from '@components/results/results.module';
import { SimulationModule } from '@components/simulation/simulation.module';
import { RedirectSilentRenewComponent } from '@core/auth/redirect-silent-renew/redirect-silent-renew.component';
import { SigninOidcComponent } from '@core/auth/signin-oidc/signin-oidc.component';
import { CoreModule } from '@core/core.module';
import { DialogComponent } from '@core/dialog/dialog.component';
import { LoadedDatasetComponent } from '@core/dialog/loaded-dataset/loaded-dataset.component';
import { ErrorPagesModule } from '@core/error-pages/error-pages.module';
import { HomeComponent } from '@core/home/home.component';
import { LoaderModule } from '@core/loader/loader.module';
import { MaterialModule } from '@core/material.module';
import { BannerNotificationModule } from '@core/notification-banner/notification-banner.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { NgIdleModule } from '@ng-idle/core';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { RoutesModule } from '@routes/routes.module';
import { OpenIdConnectService } from '@services/auth/open-id-connect.service';
import { httpInterceptorProviders } from '@services/http-interceptors';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ToastrModule,ToastContainerDirective } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AppConfigProvider } from './app.config.provider';
import {CustomToastComponent} from '@shared/custom-toast/custom-toast-component';

export function appConfigProviderFactory(provider: AppConfigProvider) {
  return () => provider.load();
}

@NgModule({
  declarations: [
    AppComponent,
    DialogComponent,
    HomeComponent,
    LookupDataComponent,
    LookupSetupComponent,
    LoadedDatasetComponent,
    SigninOidcComponent,
    RedirectSilentRenewComponent,
    GlobalSettingsComponent,
    CustomToastComponent,
  ],
  imports: [
    CoreModule,
    BalanceSheetModule,
    BrowserAnimationsModule,
    BrowserModule,
    DialogsModule,
    ErrorPagesModule,
    ExogenousLinesEquationsModule,
    HttpClientModule,
    LiquiditySourceEquationsModule,
    AuxiliaryAccountsEquationsModule,
    ExogenousLinesModule,
    LiquiditySourcesModule,
    SimulationModule,
    ResultsModule,
    ScenariosModule,
    SpreadSheetsModule,
    MaterialModule,
    FormsModule,
    RoutesModule,
    LoaderModule,
    LookupTreeModule,
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot(),
    ToastContainerDirective,
    PopupModule,
    NgIdleModule.forRoot(),
    BannerNotificationModule,
    MatProgressBarModule,    
  ],

  providers: [
    httpInterceptorProviders,
    LookupDatabase,
    AppConfigProvider,
    { provide: APP_INITIALIZER, useFactory: appConfigProviderFactory, deps: [AppConfigProvider], multi: true },
    OpenIdConnectService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
